import { Tag, getLongestLabelMinWidth } from "@/components/elements/Tag";
import { black, lightBlue, orange, pink, teal } from "@/theme/colors";
import { CASE_STATUS } from "@/features/case/constants/caseStatus";
import { FCC } from "@/types/common";
import { TCaseMatches } from "@/api/services/main/case/dtos/get-case.dto";
import { areAllCaseMatchesFailed } from "@/features/case/utils/caseStatusHelper";

type CaseStatusType = (typeof CASE_STATUS)[keyof typeof CASE_STATUS];
type CaseStatusStyle = {
  background: string;
  title: string;
};
type Props = {
  status: CaseStatusType;
  caseMatches?: TCaseMatches[];
  isAllFailed?: boolean;
};

export const CaseTagStatus: FCC<Props> = ({ status, caseMatches = [], isAllFailed: isAllFailedProp }) => {
  const allMatchesFailed = isAllFailedProp ?? areAllCaseMatchesFailed(caseMatches);
  const showRecruitmentEnded = allMatchesFailed;

  const statusOption: Record<CaseStatusType, CaseStatusStyle> = {
    [CASE_STATUS.JOB_POSTED]: { background: black[99], title: "求人情報登録" },
    [CASE_STATUS.PREPARING_PROPOSAL]: { background: black[99], title: "人材推薦準備中" },
    [CASE_STATUS.PROPOSING_CANDIDATE]: { background: lightBlue[92], title: "人材推薦中" },
    [CASE_STATUS.INTERVIEWING]: { background: orange[97], title: "面接選考中" },
    [CASE_STATUS.OFFERED]: { background: teal[100], title: "内定" },
    [CASE_STATUS.WAITING_FOR_JOINING]: { background: teal[100], title: "入社待ち" },
    [CASE_STATUS.RECRUITMENT_STOPPED]: showRecruitmentEnded
      ? { background: pink[96], title: "募集終了" }
      : { background: teal[100], title: "入社待ち" },
  };

  const current = statusOption[status];

  // Auto-fit every pill to the longest status label so all share one width (matching the talent list).
  const minWidth = getLongestLabelMinWidth(Object.values(statusOption).map((option) => option.title));

  return <Tag color={current.background} textColor={black[30]} title={current.title} fontWeight={400} size="medium" minWidth={minWidth} />;
};
